import request from '@/utils/request'
const apiPath = '/cust/customerSub'
import { downloadBlob } from '@/utils/download'
const customerSubApi = {
  /**
   * 新增【大客户】
   */
  create(data) {
    return request.post(apiPath + '/tee/setBig', data)
  },
  setNotBig(data) {
    return request.post(apiPath + '/tee/setNotBig', data)
  },
  /**
   * 修改【大客户】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【大客户】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查询【大客户】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【大客户】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【大客户】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },

  importExcelCustomerBig(data) {
    return request.post(`${apiPath}/tee/import`, data, { isFormData: 1 })
  },
  importExcelCustomertemplate(query) {
    return request.get(`${apiPath}/tee/template`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '模板.xlsx'))
  },
}
export default customerSubApi
